import React from 'react';
import { Edit, useForm } from '@refinedev/antd';
import { Descriptions, Form, Input, Select, Typography } from 'antd';
import { UserRole, UserStatus } from '@wellverse/shared-ts';
import { UserMemberTier } from './member-tier';
import { UserEfxMembership } from './efx-membership';
import { UserFeatureAccess } from './feature-access';

export const UserEdit: React.FC = () => {
  const { formProps, saveButtonProps, id, queryResult } = useForm({ resource: 'users' });
  const user = queryResult?.data?.data;

  return (
    <Edit resource="users" saveButtonProps={saveButtonProps}>
      {/* What the app's Add Friends screen accepts, so support can look a
          member up or send them a request without asking for it. */}
      <Descriptions column={3} size="small" bordered style={{ marginBottom: 24 }}>
        <Descriptions.Item label="User ID">
          {user?.handle ? <Typography.Text copyable>{user.handle}</Typography.Text> : '—'}
        </Descriptions.Item>
        <Descriptions.Item label="Friend Code">
          {user?.friendCode ? <Typography.Text copyable>{user.friendCode}</Typography.Text> : '—'}
        </Descriptions.Item>
        <Descriptions.Item label="Referral Code">
          {user?.referralCode ? <Typography.Text copyable>{user.referralCode}</Typography.Text> : '—'}
        </Descriptions.Item>
      </Descriptions>
      <Form {...formProps} layout="vertical">
        <Form.Item label="Email" name="email" rules={[{ type: 'email' }]}>
          <Input type="email" disabled />
        </Form.Item>
        <Form.Item label="First Name" name="firstName" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Last Name" name="lastName" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Role" name="role">
          <Select>
            <Select.Option value={UserRole.USER}>User</Select.Option>
            <Select.Option value={UserRole.MODERATOR}>Moderator</Select.Option>
            <Select.Option value={UserRole.ADMIN}>Admin</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Status" name="status">
          <Select>
            <Select.Option value={UserStatus.ACTIVE}>Active</Select.Option>
            <Select.Option value={UserStatus.INACTIVE}>Inactive</Select.Option>
            <Select.Option value={UserStatus.PENDING}>Pending</Select.Option>
            <Select.Option value={UserStatus.SUSPENDED}>Suspended</Select.Option>
          </Select>
        </Form.Item>
      </Form>
      {/* Outside the form on purpose: the tier is set at RevenueCat the moment
          its own button is confirmed, not when Save is pressed. */}
      {id !== undefined && <UserMemberTier userId={String(id)} />}
      {id !== undefined && <UserEfxMembership userId={String(id)} />}
      {id !== undefined && <UserFeatureAccess userId={String(id)} />}
    </Edit>
  );
};
